import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import {useFormik, FormikContext} from "formik";
import { useDispatch } from 'react-redux';
import {setPostUpdateOrganization} from '../../store/thunk/setPostUpdateOrganization';

const ModalBalance = ({handleUpdateBalance, updateBalance, handleSelectedId, selectedId, hasAdd, handleAdd}) => {
    const dispatch = useDispatch();

    const initialValues = {
        grgreen: 0,
        gryellow: 0,
        gr02green: 0
    }

    const onSubmit = (store) => {
        store.id = selectedId;
        store.hasAdd = hasAdd;
        dispatch(setPostUpdateOrganization(store));
        handleSelectedId(0)
        handleUpdateBalance(false);

        formik.resetForm();
    }

    const formik = useFormik({onSubmit, initialValues});

    return (
        <Dialog 
            onClose={() => handleUpdateBalance(false)} 
            open={updateBalance}
        >
            <FormikContext.Provider value={formik}>
                <form onSubmit={formik.handleSubmit}>
                    <div style={{padding: 20}}>
                        <h3 style={{padding: 0, margin: 0, fontFamily: 'Montserrat, sans-serif', fontSize: 18}}>Пополнение баланса</h3>
                        <label htmlFor="" style={{display: 'flex', flexDirection: 'column', marginTop: 8}}>
                            <span>GR-GREEN</span>
                            <input 
                                type="text"
                                style={{
                                    margin: 0,
                                    border: '1px solid #e5e5e5',
                                    borderRadius: 4,
                                    width: 'calc(100% - 20px)',
                                    height: 30,
                                    padding: '5px 10px',
                                }}
                                value={formik.values.grgreen}
                                onChange={(v) => formik.setFieldValue('grgreen', v.target.value)}
                            />
                        </label>
                        <label htmlFor="" style={{display: 'flex', flexDirection: 'column', marginTop: 8}}>
                            <span>GR-YELLOW</span>
                            <input 
                                type="text"
                                style={{
                                    margin: 0,
                                    border: '1px solid #e5e5e5',
                                    borderRadius: 4,
                                    width: 'calc(100% - 20px)',
                                    height: 30,
                                    padding: '5px 10px',
                                }}
                                value={formik.values.gryellow}
                                onChange={(v) => formik.setFieldValue('gryellow', v.target.value)}
                            />
                        </label>
                        <label htmlFor="" style={{display: 'flex', flexDirection: 'column', marginTop: 8}}>
                            <span>GR02-GREEN</span>
                            <input 
                                type="text"
                                style={{
                                    margin: 0,
                                    border: '1px solid #e5e5e5',
                                    borderRadius: 4,
                                    width: 'calc(100% - 20px)',
                                    height: 30,
                                    padding: '5px 10px',
                                }}
                                value={formik.values.gr02green}
                                onChange={(v) => formik.setFieldValue('gr02green', v.target.value)}
                            />
                        </label>
                        <div style={{display: 'flex', width: '100%', marginTop: 8}}>
                            <span
                                style={{
                                    color: 'rgb(20, 27, 51)',
                                    cursor: 'pointer',
                                    padding: 10,
                                    background: 'rgb(255, 195, 36)',
                                    borderRadius: 4,
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}
                                onClick={() => {
                                    formik.submitForm()
                                }}
                            >Пополнить</span>
                        </div>
                    </div>
                </form>
            </FormikContext.Provider>
        </Dialog>
    )
}

export default ModalBalance;